<template>
  <div class="card custom-card card-primary">
    <form @submit.prevent="updateCandidate" ref="updateForm" class="candidate-info-form">
      <div class="candidate d-none d-sm-block">
        <div class="d-flex align-items-center">
          <Avatar :photo="selectedAvatar" @new="setNewAvatar" />
          <div class="candidate-main-info d-flex">
            <div class="candidate-name d-flex">
              <b v-if="!isInGlobalEditMode"
                >{{ getCandidateById.first_name }} {{ getCandidateById.last_name }}</b
              >
              <div class="d-flex fields" v-else>
                <input
                  type="text"
                  class="form-control mr-1 name-input"
                  id="first_name"
                  v-model="selectedFirstName"
                />
                <input
                  id="last_name"
                  v-model="selectedLastName"
                  type="text"
                  class="form-control name-input"
                />
              </div>
              <div class="edit-candidate">
                <div v-if="!isInGlobalEditMode">
                  <router-link to>
                    <svgHelper
                      @click.native="changeGlobalEditMode"
                      class="candidate-edit-icon"
                      name="edit"
                    />
                  </router-link>
                </div>
                <div v-else>
                  <!-- Btns -->
                  <div class="form-buttons text-right" v-show="isInGlobalEditMode">
                    <button type="button" @click="updateCandidate" class="btn btn-primary">
                      Save
                    </button>
                    <button type="button" class="btn btn-danger" @click="onCancelUpdateForm">
                      Cancel
                    </button>
                    <br />
                    <div class="d-flex ml-auto">
                      <popper
                        class="popperr ml-auto"
                        trigger="hover"
                        :options="{
                          placement: 'left',
                          modifiers: { offset: { offset: '0,10px' } },
                        }"
                      >
                        <div
                          style="padding-left:12px; padding-right: 12px; font-size: 14px"
                          class="popper opted-out custom-control custom-checkbox"
                        >
                          Delete candidate
                        </div>
                        <div slot="reference">
                          <i
                            style="cursor: pointer"
                            data-toggle="modal"
                            href="#deleteCandidateModal"
                            class="fas fa-trash-alt mt-2 mr-3 ml-auto"
                          ></i>
                        </div>
                      </popper>

                      <popper
                        v-if="getAccType === 'admin'"
                        class="popperr"
                        trigger="hover"
                        :options="{
                          placement: 'left',
                          modifiers: { offset: { offset: '0,10px' } },
                        }"
                      >
                        <div
                          style="padding-left:12px; padding-right: 12px; font-size: 14px"
                          class="popper opted-out custom-control custom-checkbox"
                        >
                          Merge duplicates
                        </div>
                        <div slot="reference">
                          <i
                            style="cursor: pointer"
                            data-toggle="modal"
                            href="#mergeCandidateModal"
                            class="fas fa-random mt-2"
                          ></i>
                        </div>
                      </popper>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Add btn -->
          <popper
            v-if="getCandidateById.exist_in_candidates_db && !isInGlobalEditMode"
            class="popperr"
            style="margin-top: 4px"
            trigger="hover"
            :options="{
              placement: 'top',
              modifiers: { offset: { offset: '0,10px' } },
            }"
          >
            <div
              style="padding-left:12px; padding-right: 12px;"
              class="popper opted-out custom-control custom-checkbox no-mobile ml-auto button-show"
            >
              The candidate has an own account
            </div>
            <div slot="reference">
              <i
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                style="font-size:18px; color:#cfcfcf; margin-right:12px"
                class="fas fa-database"
              ></i>
            </div>
          </popper>
          <button
            type="button"
            class="ml-auto btn btn-success text-nowrap d-none d-sm-block"
            @click="showModal = true"
            v-if="!isInGlobalEditMode"
          >
            Add Candidate
            <portal to="add-candidate-modal-single-view">
              <CustomMainModal @close="showModal = false" v-show="showModal">
                <template v-slot:header>
                  <h5>Add Candidate</h5>
                </template>

                <AddCandidateBtnModal v-if="showModal" @close="onCloseModal" />
              </CustomMainModal>
            </portal>
          </button>

          <portal-target name="add-candidate-modal-single-view"></portal-target>
        </div>
      </div>

      <nav class="job-controls-tabs">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a
            class="nav-item nav-link active"
            id="nav-primary-tab"
            data-toggle="tab"
            href="#nav-primary"
            role="tab"
            aria-controls="nav-primary"
            aria-selected="true"
          >
            PROFILE
          </a>
          <a
            class="nav-item nav-link"
            id="nav-cv-tab"
            data-toggle="tab"
            href="#nav-cv"
            role="tab"
            aria-controls="nav-cv"
            aria-selected="false"
            @click="onCvDocumentView($event)"
          >
            CV
          </a>
          <a
            class="nav-item nav-link mobile-hidden"
            id="nav-freelancing-tab"
            data-toggle="tab"
            href="#nav-freelancing"
            role="tab"
            aria-controls="nav-freelancing"
            aria-selected="false"
          >
            <i class="fas fa-file-contract d-block d-sm-none"></i> Freelancing
          </a>
          <a
            class="nav-item nav-link"
            id="nav-comments-tab"
            data-toggle="tab"
            href="#nav-comments"
            role="tab"
            aria-controls="nav-comments"
            aria-selected="false"
          >
            <!--  @click="showCv = false" -->
            COMMENTS
            <span v-show="getCandidateComments.length ? true : false" class="badge badge-light">{{
              getCandidateComments.length
            }}</span>
          </a>
        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent">
        <div
          class="tab-pane fade show active"
          id="nav-primary"
          role="tabpanel"
          aria-labelledby="nav-primary-tab"
        >
          <section>
            <ul class="list-group list-group-custom candidate-details">
              <div class="row">
                <li class="list-group-item col-md-12 d-block d-sm-none"></li>
                <li class="list-group-item col-md-6">
                  <div
                    v-if="!editIconState.primaryEmailFormShow && !isInGlobalEditMode"
                    @mouseover="editFields.primaryEmail = true"
                    @mouseleave="editFields.primaryEmail = false"
                    class="d-flex"
                  >
                    <span>
                      <b>Primary email</b>
                    </span>
                    <div class="edit-btn" v-if="getCandidateById.temporary_email">
                      <router-link v-if="editFields.primaryEmail" to class="mr-1">
                        <i
                          @click="showEditForm($event)"
                          id="primary-email"
                          class="fas fa-pen edit-icon"
                        ></i>
                      </router-link>
                    </div>
                    <div v-else class="mr-4"></div>
                    <div class="text-truncate">
                      <a :href="`mailto:${getCandidateById.email}`" target="_top" class="mr-3">{{
                        getCandidateById.email
                      }}</a>
                    </div>
                  </div>

                  <span class="d-flex" v-else>
                    <span class="mr-0">
                      <b>Primary email</b>
                    </span>

                    <input
                      id="email"
                      v-model="selectedPrimaryEmail"
                      type="text"
                      class="form-control mr-1"
                      :disabled="getCandidateById.temporary_email ? false : true"
                    />
                    <button
                      v-show="!isInGlobalEditMode && getCandidateById.temporary_email"
                      class="btn btn-outline btn-sm border mr-1"
                    >
                      <i class="fas fa-check"></i>
                    </button>
                    <CandidateEditFieldCancelBtn
                      v-show="!isInGlobalEditMode"
                      @clicked="editIconState.primaryEmailFormShow = false"
                    >
                      <i class="fas fa-times"></i>
                    </CandidateEditFieldCancelBtn>
                  </span>
                </li>
                <li class="list-group-item col-md-6">
                  <div
                    v-if="!editIconState.secondaryEmailFormShow && !isInGlobalEditMode"
                    @mouseover="editFields.secondaryEmail = true"
                    @mouseleave="editFields.secondaryEmail = false"
                    class="d-flex"
                  >
                    <span>
                      <b>2nd email</b>
                    </span>
                    <div class="edit-btn">
                      <router-link v-if="editFields.secondaryEmail" to class="mr-1">
                        <i
                          @click="showEditForm($event)"
                          id="email2"
                          class="fas fa-pen edit-icon"
                        ></i>
                      </router-link>
                    </div>
                    <div class="text-truncate">
                      <a
                        v-if="getCandidateById.email2"
                        :href="`mailto:${getCandidateById.email2}`"
                        class="mr-3"
                        target="_top"
                        >{{ getCandidateById.email2 }}</a
                      >
                      <span v-else>N/A</span>
                    </div>
                  </div>

                  <span class="d-flex" v-else>
                    <span class="mr-0">
                      <b>2nd email</b>
                    </span>

                    <input
                      id="email2"
                      v-model="selectedSecondaryEmail"
                      type="text"
                      class="form-control mr-1"
                    />
                    <button v-show="!isInGlobalEditMode" class="btn btn-outline btn-sm border mr-1">
                      <i class="fas fa-check"></i>
                    </button>
                    <CandidateEditFieldCancelBtn
                      v-show="!isInGlobalEditMode"
                      @clicked="editIconState.secondaryEmailFormShow = false"
                    >
                      <i class="fas fa-times"></i>
                    </CandidateEditFieldCancelBtn>
                  </span>
                </li>

                <li class="list-group-item col-md-6">
                  <div
                    v-if="!editIconState.phoneFormShow && !isInGlobalEditMode"
                    @mouseover="editFields.phone = true"
                    @mouseleave="editFields.phone = false"
                    class="d-flex"
                  >
                    <span>
                      <b>Phone number</b>
                    </span>
                    <div class="edit-btn">
                      <router-link v-if="editFields.phone" to>
                        <i
                          @click="showEditForm($event)"
                          id="phone-number"
                          class="fas fa-pen edit-icon"
                        ></i>
                      </router-link>
                    </div>
                    <div>
                      <span v-if="getCandidateById.phone"
                        ><a :href="`tel:${getCandidateById.phone}`">{{
                          getCandidateById.phone
                        }}</a></span
                      >
                    </div>
                  </div>

                  <span class="d-flex" v-else>
                    <span class="mr-0">
                      <b>Phone number</b>
                    </span>
                    <div class="new-phone">
                      <v-select
                        @input="addCountryCode(countryCode)"
                        style="font-size: 14px; height: 42px"
                        v-model="countryCode"
                        :options="
                          [...getAllCountries].map(item => `${item.phone_code} ${item.name}`)
                        "
                        :clearable="false"
                      >
                        <template v-slot:option="option">
                          {{ option.label }}
                        </template>
                      </v-select>
                      <input class="form-control" id="phone" v-model="selectedPhone" type="tel" />

                      <button
                        v-show="!isInGlobalEditMode"
                        type="submit"
                        class="btn btn-outline btn-sm border mr-1"
                      >
                        <i class="fas fa-check"></i>
                      </button>

                      <CandidateEditFieldCancelBtn
                        v-show="!isInGlobalEditMode"
                        @clicked="editIconState.phoneFormShow = false"
                      >
                        <i class="fas fa-times"></i>
                      </CandidateEditFieldCancelBtn>
                    </div>

                    <!--    </form> -->
                  </span>
                </li>
                <li class="list-group-item col-md-6">
                  <div
                    v-if="!editIconState.streetAddrFormShow && !isInGlobalEditMode"
                    @mouseover="editFields.streetAddr = true"
                    @mouseleave="editFields.streetAddr = false"
                    class="d-flex"
                  >
                    <span>
                      <b>Street address</b>
                    </span>
                    <div class="edit-btn">
                      <router-link v-if="editFields.streetAddr" to>
                        <i
                          @click="showEditForm($event)"
                          id="street"
                          class="fas fa-pen edit-icon"
                        ></i>
                      </router-link>
                    </div>
                    <div>{{ getCandidateById.street || 'N/A' }}</div>
                  </div>

                  <span class="d-flex" v-else>
                    <span class="mr-0">
                      <b>Street address</b>
                    </span>

                    <input
                      id="street"
                      v-model="selectedAddress"
                      type="text"
                      class="form-control mr-1"
                    />
                    <button
                      v-show="!isInGlobalEditMode"
                      type="submit"
                      class="btn btn-outline btn-sm border mr-1"
                    >
                      <i class="fas fa-check"></i>
                    </button>
                    <CandidateEditFieldCancelBtn
                      v-show="!isInGlobalEditMode"
                      @clicked="editIconState.streetAddrFormShow = false"
                    >
                      <i class="fas fa-times"></i>
                    </CandidateEditFieldCancelBtn>
                  </span>
                </li>
                <li class="list-group-item col-md-6">
                  <div
                    v-if="!editIconState.postalFormShow && !isInGlobalEditMode"
                    @mouseover="editFields.postal = true"
                    @mouseleave="editFields.postal = false"
                    class="d-flex"
                  >
                    <span>
                      <b>Postal code</b>
                    </span>
                    <div class="edit-btn">
                      <router-link v-if="editFields.postal" to>
                        <i
                          @click="showEditForm($event)"
                          id="postal"
                          class="fas fa-pen edit-icon"
                        ></i>
                      </router-link>
                    </div>
                    <div>{{ getCandidateById.postal || 'N/A' }}</div>
                  </div>

                  <span class="d-flex" v-else>
                    <span class="mr-0">
                      <b>Postal code</b>
                    </span>

                    <input
                      id="selected-postal"
                      v-model="selectedPostalCode"
                      type="text"
                      class="form-control mr-1"
                    />
                    <button
                      v-show="!isInGlobalEditMode"
                      type="submit"
                      class="btn btn-outline btn-sm border mr-1"
                    >
                      <i class="fas fa-check"></i>
                    </button>
                    <CandidateEditFieldCancelBtn
                      v-show="!isInGlobalEditMode"
                      @clicked="editIconState.postalFormShow = false"
                    >
                      <i class="fas fa-times"></i>
                    </CandidateEditFieldCancelBtn>
                  </span>
                </li>
                <li class="list-group-item col-md-6">
                  <div
                    v-if="!editIconState.cityFormShow && !isInGlobalEditMode"
                    @mouseover="editFields.city = true"
                    @mouseleave="editFields.city = false"
                    class="d-flex"
                  >
                    <span>
                      <b>Location</b>
                    </span>
                    <div class="edit-btn">
                      <router-link v-if="editFields.city" to>
                        <i @click="showEditForm($event)" id="city" class="fas fa-pen edit-icon"></i>
                      </router-link>
                    </div>
                    <div
                      v-if="
                        getCandidateById &&
                          getCandidateById.city &&
                          getCandidateById.city.name &&
                          getCandidateById.country.name
                      "
                    >
                      {{ getCandidateById.city.name }},
                      {{ getCandidateById.country.name }}
                    </div>

                    <div v-else style="font-size: 13px; position:relative; top:-12px">
                      Please enter City and Country before editing other information.
                    </div>
                  </div>

                  <span class="d-flex new-location" v-else>
                    <span class="mr-0">
                      <b>Location</b>
                    </span>
                    <div class="location-container">
                      <v-select
                        class="country-select"
                        v-model="selectedCountry"
                        @input="
                          fetchCitiesByCountryId($event);
                          clearCity();
                        "
                        label="name"
                        :options="getAllCountries"
                        :reduce="country => country"
                        :clearable="false"
                      >
                        <template v-slot:no-options="{ search, searching }">
                          <template v-if="searching && search.length >= 3">
                            No results found for <em>{{ search }}</em
                            >.
                          </template>
                          <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                        </template>
                      </v-select>
                      <v-select
                        class="city-select"
                        v-model="selectedCity"
                        @input="setCityModel($event)"
                        label="name"
                        :options="getCitiesListByCountry"
                        :reduce="city => city"
                        :clearable="true"
                      >
                        <template v-slot:no-options>
                          <div style="opacity: 0.5">Please select a country first</div>
                        </template>
                      </v-select>
                    </div>
                    <button
                      v-show="!isInGlobalEditMode"
                      type="submit"
                      class="btn btn-outline btn-sm border mr-1"
                    >
                      <i class="fas fa-check"></i>
                    </button>
                    <CandidateEditFieldCancelBtn
                      v-show="!isInGlobalEditMode"
                      @clicked="editIconState.cityFormShow = false"
                    >
                      <i class="fas fa-times"></i>
                    </CandidateEditFieldCancelBtn>
                  </span>
                </li>

                <li class="list-group-item col-md-6">
                  <div
                    v-if="!editIconState.relocationFormShow && !isInGlobalEditMode"
                    @mouseover="editFields.editRelocation = true"
                    @mouseleave="editFields.editRelocation = false"
                    class="d-flex"
                  >
                    <span>
                      <b>Relocation</b>
                    </span>

                    <div class="edit-btn">
                      <router-link v-if="editFields.editRelocation" to>
                        <i
                          @click="showEditForm($event)"
                          id="relocation"
                          class="fas fa-pen edit-icon"
                        ></i>
                      </router-link>
                    </div>

                    <div class="custom-control">
                      <span>{{ selectedRelocation ? 'Yes' : 'No' }}</span>
                    </div>
                  </div>
                  <span class="d-flex" v-else>
                    <span class="mr-0">
                      <b>Relocation</b>
                    </span>

                    <div class="custom-control custom-checkbox">
                      <input
                        style="position: absolute; left: -23px; z-index: 999999"
                        id="relocation"
                        class="mr-2 custom-control-input"
                        type="checkbox"
                        aria-label
                        v-model="selectedRelocation"
                      />
                      <label class="custom-control-label" for="relocation"></label>
                    </div>

                    <button
                      v-show="!isInGlobalEditMode"
                      type="submit"
                      class="btn btn-outline btn-sm border mr-1 ml-2"
                    >
                      <i class="fas fa-check"></i>
                    </button>

                    <CandidateEditFieldCancelBtn
                      v-show="!isInGlobalEditMode"
                      @clicked="editIconState.relocationFormShow = false"
                    >
                      <i class="fas fa-times"></i>
                    </CandidateEditFieldCancelBtn>
                  </span>
                </li>
                <li class="list-group-item col-md-6">
                  <div
                    v-if="!editIconState.linkedinFormShow && !isInGlobalEditMode"
                    @mouseover="editFields.linkedin = true"
                    @mouseleave="editFields.linkedin = false"
                    class="d-flex"
                  >
                    <span>
                      <b>LinkedIn</b>
                    </span>
                    <div class="edit-btn">
                      <router-link v-if="editFields.linkedin" to>
                        <i
                          @click="showEditForm($event)"
                          id="linkedin"
                          class="fas fa-pen edit-icon"
                        ></i>
                      </router-link>
                    </div>
                    <div class="truncate">
                      <a
                        class="text-nowrap"
                        v-if="getCandidateById.linkedin"
                        :href="checkLinkedIin(getCandidateById.linkedin)"
                        target="_blank"
                        >{{ getCandidateById.linkedin }}</a
                      >
                      <span
                        v-else
                        style="color: #0088cc; text-decoration: none; background-color: transparent"
                        >N/A</span
                      >
                    </div>
                  </div>

                  <span class="d-flex" v-else>
                    <span class="mr-0">
                      <b>Linkedin</b>
                    </span>

                    <input
                      id="linkedin"
                      v-model="selectedLinkedin"
                      type="text"
                      class="form-control mr-1"
                    />
                    <button
                      v-show="!isInGlobalEditMode"
                      type="submit"
                      class="btn btn-outline btn-sm border mr-1"
                    >
                      <i class="fas fa-check"></i>
                    </button>
                    <CandidateEditFieldCancelBtn
                      v-show="!isInGlobalEditMode"
                      @clicked="editIconState.linkedinFormShow = false"
                    >
                      <i class="fas fa-times"></i>
                    </CandidateEditFieldCancelBtn>
                  </span>
                </li>
                <li class="list-group-item col-md-6">
                  <div
                    v-if="!editIconState.webpageFormShow && !isInGlobalEditMode"
                    @mouseover="editFields.webpage = true"
                    @mouseleave="editFields.webpage = false"
                    class="d-flex"
                  >
                    <span>
                      <b>Webpage</b>
                    </span>
                    <div class="edit-btn">
                      <router-link v-if="editFields.webpage" to class="mr-1">
                        <i
                          @click="showEditForm($event)"
                          id="webpage"
                          class="fas fa-pen edit-icon"
                        ></i>
                      </router-link>
                    </div>
                    <div class="truncate">
                      <a
                        v-if="getCandidateById.webpage"
                        :href="checkLinkedIin(getCandidateById.webpage)"
                        target="_blank"
                        >{{ getCandidateById.webpage | prettifyUrl }}</a
                      >
                      <span
                        v-else
                        style="color: #0088cc; text-decoration: none; background-color: transparent"
                        >N/A</span
                      >
                    </div>
                  </div>

                  <div class="d-flex" v-else>
                    <span class="mr-0">
                      <b>Webpage</b>
                    </span>

                    <input
                      id="webpage"
                      v-model="selectedWebPage"
                      type="text"
                      class="form-control mr-1"
                    />
                    <button
                      v-show="!isInGlobalEditMode"
                      type="submit"
                      class="btn btn-outline btn-sm border mr-1"
                    >
                      <i class="fas fa-check"></i>
                    </button>
                    <CandidateEditFieldCancelBtn
                      v-show="!isInGlobalEditMode"
                      @clicked="editIconState.webpageFormShow = false"
                    >
                      <i class="fas fa-times"></i>
                    </CandidateEditFieldCancelBtn>
                  </div>
                </li>
                <li class="list-group-item col-md-6">
                  <div
                    v-if="!editIconState.competencesFormShow && !isInGlobalEditMode"
                    @mouseover="editFields.competences = true"
                    @mouseleave="editFields.competences = false"
                    class="d-flex"
                  >
                    <span>
                      <b>Competencies</b>
                    </span>
                    <div class="edit-btn">
                      <router-link v-if="editFields.competences" to class="mr-1">
                        <i
                          @click="showEditForm($event)"
                          id="competences"
                          class="fas fa-pen edit-icon"
                        ></i>
                      </router-link>
                    </div>

                    <div class="tech-icons dropdown">
                      <div
                        class="icon-container"
                        v-for="(competence, i) in getCandidateById.competences
                          ? getCandidateById.competences.slice(0, 4)
                          : []"
                        :key="i"
                      >
                        <IconMapper :competence="competence"></IconMapper>
                      </div>
                      <i
                        v-if="getCandidateById.competences.length > 4"
                        class="fas fa-ellipsis-h"
                      ></i>

                      <button
                        class="btn btn-secondary dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      ></button>
                      <div
                        v-if="getCandidateById.competences.length > 4"
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="list-inline">
                          <li
                            class="list-inline-item"
                            v-for="(subCompetence, $index) in getCandidateById.competences
                              ? getCandidateById.competences.slice(4)
                              : []"
                            :key="$index"
                          >
                            <IconMapper :competence="subCompetence"></IconMapper>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex issue" v-else>
                    <span class="mr-0">
                      <b>Competencies</b>
                    </span>
                    <!--  @search="oncompetenceSearch" -->
                    <v-select
                      class="w-100"
                      v-model="selectedCompetences"
                      label="name"
                      :options="getCompetencesFilterList"
                      :reduce="competence => competence"
                      :clearable="true"
                      multiple
                    >
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching && search.length >= 3">
                          No results found for <em>{{ search }}</em
                          >.
                        </template>
                        <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                      </template>
                    </v-select>

                    <button
                      v-show="!isInGlobalEditMode"
                      type="submit"
                      class="btn btn-outline btn-sm border mr-1"
                    >
                      <i class="fas fa-check"></i>
                    </button>
                    <CandidateEditFieldCancelBtn
                      v-show="!isInGlobalEditMode"
                      @clicked="editIconState.competencesFormShow = false"
                    >
                      <i class="fas fa-times"></i>
                    </CandidateEditFieldCancelBtn>
                  </div>

                  <!-- Start Dropdown list of competences -->
                  <div class="popup d-flex justify-content-around" v-if="showMore">
                    <div
                      class="text-center icon-container"
                      v-for="(competence, i) in getCandidateById.competences"
                      :key="i"
                    >
                      <!--   <IconMapper :competence="competence"></IconMapper> -->
                    </div>
                  </div>
                  <!-- End dropdown competences -->
                </li>
                <li class="list-group-item col-md-6">
                  <div
                    v-if="!editIconState.languagesFormShow && !isInGlobalEditMode"
                    @mouseover="editFields.languages = true"
                    @mouseleave="editFields.languages = false"
                    class="d-flex"
                  >
                    <span>
                      <b>Languages</b>
                    </span>
                    <div class="edit-btn">
                      <router-link v-if="editFields.languages" class="mr-2" to>
                        <i
                          @click="showEditForm($event)"
                          id="languages"
                          class="fas fa-pen edit-icon"
                        ></i>
                      </router-link>
                    </div>
                    <div
                      class="dropdown tech-icons"
                      style="margin-top:0!important"
                      v-if="getCandidateById.languages.length"
                    >
                      <span
                        v-for="language in getCandidateById.languages.slice(0, 3)"
                        :class="['candidate-tag', 'mr-3']"
                        :key="language.language_id"
                        :id="language.language_id"
                        >{{ language.name }}</span
                      >
                      <button
                        style="top:0;padding-top:29px"
                        class="btn btn-secondary dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      ></button>
                      <i
                        v-if="getCandidateById.languages.length > 3"
                        class="fas fa-ellipsis-h"
                        style="position:absolute;top:5px!important; right:0px!important; pointer-events:none!important"
                      ></i>
                      <div
                        v-if="getCandidateById.languages.length > 3"
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="list-inline">
                          <li
                            style="width:auto!important; margin:12px 2px!important"
                            class="list-inline-item mt-3"
                            v-for="(subLanguage, index) in getCandidateById.languages.slice(3)"
                            :key="index"
                          >
                            <span :class="['candidate-tag']" :key="subLanguage.language_id">{{
                              subLanguage.name
                            }}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div v-else>
                      <span>N/A</span>
                    </div>
                  </div>

                  <span class="d-flex issue" v-else>
                    <span class="mr-0">
                      <b>Languages</b>
                    </span>

                    <v-select
                      class="w-100"
                      v-model="selectedLanguages"
                      @search="onLanguageSearch"
                      label="name"
                      :options="languagesOptions"
                      :reduce="lang => lang"
                      :clearable="true"
                      multiple
                    >
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching && search.length >= 3">
                          No results found for <em>{{ search }}</em
                          >.
                        </template>
                        <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                      </template>
                    </v-select>

                    <button v-show="!isInGlobalEditMode" class="btn btn-outline btn-sm border mr-1">
                      <i class="fas fa-check"></i>
                    </button>
                    <CandidateEditFieldCancelBtn
                      v-show="!isInGlobalEditMode"
                      @clicked="editIconState.languagesFormShow = false"
                    >
                      <i class="fas fa-times"></i>
                    </CandidateEditFieldCancelBtn>
                  </span>
                </li>

                <li class="list-group-item col-md-6">
                  <div
                    v-if="!editIconState.employmentFormShow && !isInGlobalEditMode"
                    @mouseover="editFields.employment = true"
                    @mouseleave="editFields.employment = false"
                    class="d-flex"
                  >
                    <span>
                      <b>Employment</b>
                    </span>
                    <div class="edit-btn">
                      <router-link v-if="editFields.employment" to>
                        <i
                          @click="showEditForm($event)"
                          id="employment"
                          class="fas fa-pen edit-icon"
                        ></i>
                      </router-link>
                    </div>
                    <div>
                      {{
                        getCandidateById.employment
                          ? getEmploymentType(getCandidateById.employment).name
                          : ''
                      }}
                    </div>
                  </div>

                  <span class="d-flex" v-else>
                    <span class="mr-0">Employment</span>

                    <select
                      v-model="selectedEmploymentType"
                      class="employment-select form-control w-100"
                    >
                      <option selected :value="1">Employment</option>
                      <option :value="2">Self-employment</option>
                      <option :value="3">Employment / Self-Employment</option>
                    </select>

                    <button
                      v-show="!isInGlobalEditMode"
                      type="submit"
                      class="btn btn-outline btn-sm border mr-1"
                    >
                      <i class="fas fa-check"></i>
                    </button>
                    <CandidateEditFieldCancelBtn
                      v-show="!isInGlobalEditMode"
                      @clicked="editIconState.employmentFormShow = false"
                    >
                      <i class="fas fa-times"></i>
                    </CandidateEditFieldCancelBtn>
                  </span>
                </li>

                <li class="list-group-item col-md-6">
                  <div
                    v-if="!editIconState.optedoutFormShow && !isInGlobalEditMode"
                    @mouseover="editFields.editOptedout = true"
                    @mouseleave="editFields.editOptedout = false"
                    class="d-flex"
                  >
                    <span>
                      <b>Opted-out</b>
                    </span>

                    <div class="edit-btn">
                      <router-link v-if="editFields.editOptedout" to>
                        <i
                          @click="showEditForm($event)"
                          id="optedout"
                          class="fas fa-pen edit-icon"
                        ></i>
                      </router-link>
                    </div>

                    <div class="custom-control">
                      <span>{{ getCandidateById.opted_out ? 'Yes' : 'No' }}</span>
                    </div>
                  </div>

                  <div class="d-flex" v-else>
                    <span class="mr-0">
                      <b>Opted-out</b>
                    </span>

                    <div class="custom-control custom-checkbox">
                      <input
                        id="optedout12"
                        class="custom-control-input"
                        type="checkbox"
                        aria-label
                        v-model="selectedOptedOut"
                      />
                      <label class="custom-control-label mr-2" for="optedout12"></label>
                    </div>

                    <button
                      v-show="!isInGlobalEditMode"
                      type="submit"
                      class="btn btn-outline btn-sm border mr-1"
                    >
                      <i class="fas fa-check"></i>
                    </button>

                    <CandidateEditFieldCancelBtn
                      v-show="!isInGlobalEditMode"
                      @clicked="editIconState.optedoutFormShow = false"
                    >
                      <i class="fas fa-times"></i>
                    </CandidateEditFieldCancelBtn>
                  </div>
                </li>

                <li class="list-group-item col-md-6">
                  <div
                    v-if="!editIconState.blockedFormShow && !isInGlobalEditMode"
                    @mouseover="editFields.editBlocked = true"
                    @mouseleave="editFields.editBlocked = false"
                    class="d-flex"
                  >
                    <span>
                      <b>Blocked</b>
                    </span>

                    <div class="edit-btn">
                      <router-link v-if="editFields.editBlocked" to>
                        <i
                          @click="showEditForm($event)"
                          id="blocked"
                          class="fas fa-pen edit-icon"
                        ></i>
                      </router-link>
                    </div>

                    <div class="custom-control">
                      <span>{{ selectedBlocked ? 'Yes' : 'No' }}</span>
                    </div>
                  </div>

                  <div class="d-flex" v-else>
                    <span class="mr-0">
                      <b>Blocked</b>
                    </span>

                    <div class="custom-control custom-checkbox">
                      <input
                        id="blocked"
                        class="custom-control-input"
                        type="checkbox"
                        aria-label
                        v-model="selectedBlocked"
                      />
                      <label class="custom-control-label mr-2" for="blocked"></label>
                    </div>

                    <button
                      v-show="!isInGlobalEditMode"
                      type="submit"
                      class="btn btn-outline btn-sm border mr-1"
                    >
                      <i class="fas fa-check"></i>
                    </button>

                    <CandidateEditFieldCancelBtn
                      v-show="!isInGlobalEditMode"
                      @clicked="editIconState.blockedFormShow = false"
                    >
                      <i class="fas fa-times"></i>
                    </CandidateEditFieldCancelBtn>
                  </div>
                </li>

                <li class="list-group-item col-md-6">
                  <div
                    v-if="!editIconState.sourcesFormShow && !isInGlobalEditMode"
                    @mouseover="editFields.sources = true"
                    @mouseleave="editFields.sources = false"
                    class="d-flex"
                  >
                    <span>
                      <b>Source</b>
                    </span>

                    <div class="edit-btn">
                      <router-link v-if="editFields.sources" to>
                        <i
                          @click="showEditForm($event)"
                          id="sources"
                          class="fas fa-pen edit-icon"
                        ></i>
                      </router-link>
                    </div>
                    <div class="text-truncate">
                      {{ getCandidateById.source.description }} ({{
                        getCandidateById.source.source_name
                      }})
                    </div>
                  </div>
                  <span class="d-flex" v-else>
                    <span class="mr-0">
                      <b>Source</b>
                    </span>

                    <input
                      :value="getCandidateById.source.description"
                      type="text"
                      class="form-control mr-1"
                      disabled
                    />
                    <button
                      v-show="!isInGlobalEditMode"
                      type="submit"
                      class="btn btn-outline btn-sm border mr-1"
                    >
                      <i class="fas fa-check"></i>
                    </button>
                    <CandidateEditFieldCancelBtn
                      v-show="!isInGlobalEditMode"
                      @clicked="editIconState.sourcesFormShow = false"
                    >
                      <i class="fas fa-times"></i>
                    </CandidateEditFieldCancelBtn>
                  </span>
                </li>

                <li class="list-group-item col-md-6">
                  <div
                    v-if="!editIconState.createdByFormShow && !isInGlobalEditMode"
                    @mouseover="editFields.createdBy = true"
                    @mouseleave="editFields.createdBy = false"
                    class="d-flex"
                  >
                    <span>
                      <b>Created by</b>
                    </span>
                    <div class="edit-btn">
                      <router-link v-if="editFields.createdBy" to>
                        <i
                          @click="showEditForm($event)"
                          id="createdBy"
                          class="fas fa-pen edit-icon"
                        ></i>
                      </router-link>
                    </div>
                    <div>{{ getCandidateById.created_by || 'N/A' }}</div>
                  </div>

                  <span class="d-flex" v-else>
                    <span class="mr-0">
                      <b>Created by</b>
                    </span>

                    <input
                      disabled
                      :value="getCandidateById.created_by"
                      type="text"
                      class="form-control mr-1"
                    />
                    <!--  <button
                      v-show="!isInGlobalEditMode"
                      type="submit"
                      class="btn btn-outline btn-sm border mr-1"
                    >
                      <i class="fas fa-check"></i>
                    </button> -->
                    <CandidateEditFieldCancelBtn
                      v-show="!isInGlobalEditMode"
                      @clicked="editIconState.createdByFormShow = false"
                    >
                      <i class="fas fa-times"></i>
                    </CandidateEditFieldCancelBtn>
                  </span>
                </li>
                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span class="mr-0">
                      <b>Created date</b>
                    </span>
                    <span v-if="!isInGlobalEditMode" class="creation-date">{{
                      getCandidateById.created_at
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}</span>

                    <input
                      v-if="isInGlobalEditMode"
                      class="form-control mr-1"
                      type="text"
                      disabled
                      :value="
                        getCandidateById.created_at
                          | formatDate({
                            format: getUserProfile.format_date,
                            timezone: getUserProfile.timezone,
                            hasHourAndMinutes: false,
                          })
                      "
                    />
                  </div>
                </li>

                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>Last updated</b>
                    </span>
                    <span v-if="!isInGlobalEditMode" class="creation-date">{{
                      getCandidateById.updated_at
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}</span>

                    <input
                      v-else
                      class="form-control"
                      disabled
                      type="text"
                      :value="
                        getCandidateById.updated_at
                          | formatDate({
                            format: getUserProfile.format_date,
                            timezone: getUserProfile.timezone,
                            hasHourAndMinutes: false,
                          })
                      "
                    />
                  </div>
                </li>

                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>Privacy</b>
                    </span>
                    <span v-if="!isInGlobalEditMode" class="creation-date">
                      {{
                        getCandidateById.privacy_date
                          ? `Accepted on ${getCandidateById.privacy_date}`
                          : 'Not accepted'
                      }}
                    </span>

                    <input v-else type="text" class="form-control" disabled value="Yes" />
                  </div>
                </li>
                <li class="list-group-item col-md-6">
                  <div class="d-flex">
                    <span>
                      <b>Campaign</b>
                    </span>
                    <span v-if="!isInGlobalEditMode" class="creation-date">
                      {{ getCandidateById.campaign_id ? getCandidateById.campaign_id : 'N/A' }}
                    </span>

                    <input v-else type="text" class="form-control" disabled value="test campain" />
                  </div>
                </li>
              </div>
            </ul>
            <!--  </form> -->
          </section>
        </div>

        <Spinner :isLoading="isLoading" />
        <div
          class="tab-pane fade"
          id="nav-cv"
          style="position:relative"
          role="tabpanel"
          aria-labelledby="nav-cv-tab"
        >
          <Spinner :isLoading="isCvLoading" />
          <embed
            v-if="showCv"
            :src="defaultCv"
            width="100%"
            height="820px"
            type="application/pdf"
          />
          <span v-else>{{ previewCvMessage }}</span>
        </div>
        <div
          class="tab-pane fade"
          id="nav-comments"
          role="tabpanel"
          aria-labelledby="nav-comments-tab"
        >
          <Comments
            :key="key"
            @add-candidate-comment="addCommentHandler"
            @remove-comment="deleteCommentHandler"
            @edit-comment="editCommentHandler"
            :uuid="this.$route.params.candidate_id"
            :commentsList="getCandidateComments"
          />
        </div>
        <div
          class="tab-pane fade"
          id="nav-activity"
          role="tabpanel"
          aria-labelledby="nav-activity-tab"
        >
          <Activities :activities="getCandidateById.activities" />
        </div>
        <div class="tab-pane fade" id="nav-emails" role="tabpanel" aria-labelledby="nav-emails-tab">
          <Emails :emails="getCandidateEmails" />
        </div>
        <div
          class="tab-pane fade"
          id="nav-freelancing"
          role="tabpanel"
          aria-labelledby="nav-freelancing-tab"
        >
          <ul
            class="list-group list-group-custom candidate-details"
            style="overflow: visible!important;"
          >
            <div class="row">
              <li class="list-group-item col-md-6">
                <div
                  v-if="!editIconState.freelancerFormShow"
                  @mouseover="editFields.freelancer = true"
                  @mouseleave="editFields.freelancer = false"
                  class="d-flex"
                >
                  <span style="width:155px!important">
                    <b>Signing date</b>
                  </span>
                  <div
                    v-if="
                      getCandidateById.freelancing_network &&
                        getCandidateById.freelancing_network.signing_date
                    "
                  >
                    {{
                      getCandidateById.freelancing_network.signing_date
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}
                  </div>
                </div>
                <div v-else class="d-flex">
                  <span style="width:155px!important">
                    <b>Signing date</b>
                  </span>
                  <div
                    v-if="
                      getCandidateById.freelancing_network &&
                        getCandidateById.freelancing_network.signing_date
                    "
                  >
                    {{
                      getCandidateById.freelancing_network.signing_date
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}
                  </div>
                </div>
              </li>

              <li class="list-group-item col-md-6">
                <div
                  v-if="!editIconState.statusFormShow"
                  @mouseover="editFields.status = true"
                  @mouseleave="editFields.status = false"
                  class="d-flex"
                >
                  <span>
                    <b>Status</b>
                  </span>
                  <div v-if="getCandidateById.freelancing_network" class="edit-btn">
                    <router-link v-if="editFields.status" to>
                      <i @click="showEditForm($event)" id="status" class="fas fa-pen edit-icon"></i>
                    </router-link>
                  </div>
                  <div v-if="getCandidateById.freelancing_network">
                    {{ freelancingStatus(freeLancingProfile.status) }}
                  </div>
                  <div v-else>
                    {{ freelancingStatus(1) }}
                  </div>
                </div>

                <span class="d-flex" v-else>
                  <span class="mr-0">Status</span>
                  <select
                    v-model="editFreeLancer.status"
                    class="employment-select form-control w-100"
                  >
                    <option :value="1">Not applied</option>
                    <option :value="2">Applied</option>
                    <option :value="3">Revised</option>
                    <option :value="4">Approved</option>
                    <option :value="5">Declined</option>
                  </select>
                  <button type="submit" class="btn btn-outline btn-sm border mr-1">
                    <i class="fas fa-check"></i>
                  </button>
                  <CandidateEditFieldCancelBtn @clicked="editIconState.statusFormShow = false">
                    <i class="fas fa-times"></i>
                  </CandidateEditFieldCancelBtn>
                </span>
              </li>

              <li class="list-group-item col-md-6">
                <div
                  v-if="!editIconState.companyNameFormShow"
                  @mouseover="editFields.companyName = true"
                  @mouseleave="editFields.companyName = false"
                  class="d-flex"
                >
                  <span>
                    <b>Company name</b>
                  </span>
                  <div v-if="getCandidateById.freelancing_network" class="edit-btn">
                    <router-link v-if="editFields.companyName" to>
                      <i
                        @click="showEditForm($event)"
                        id="companyname"
                        class="fas fa-pen edit-icon"
                      ></i>
                    </router-link>
                  </div>
                  <div>
                    {{ freeLancingProfile.company }}
                  </div>
                </div>

                <span class="d-flex" v-else>
                  <span class="mr-0">Company name</span>
                  <input
                    id="companyname-form"
                    v-model="editFreeLancer.company"
                    type="text"
                    class="form-control mr-1"
                  />
                  <button type="submit" class="btn btn-outline btn-sm border mr-1">
                    <i class="fas fa-check"></i>
                  </button>
                  <CandidateEditFieldCancelBtn @clicked="editIconState.companyNameFormShow = false">
                    <i class="fas fa-times"></i>
                  </CandidateEditFieldCancelBtn>
                </span>
              </li>

              <li class="list-group-item col-md-6">
                <div
                  v-if="!editIconState.regFormShow"
                  @mouseover="editFields.reg = true"
                  @mouseleave="editFields.reg = false"
                  class="d-flex"
                >
                  <span>
                    <b>Registration No</b>
                  </span>
                  <div v-if="getCandidateById.freelancing_network" class="edit-btn">
                    <router-link v-if="editFields.reg" to>
                      <i @click="showEditForm($event)" id="reg" class="fas fa-pen edit-icon"></i>
                    </router-link>
                  </div>
                  <div>
                    {{ freeLancingProfile.regNumber }}
                  </div>
                </div>

                <span class="d-flex" v-else>
                  <span class="mr-0">Registration No</span>
                  <input
                    id="reg"
                    v-model="editFreeLancer.regNumber"
                    type="text"
                    class="form-control mr-1"
                  />
                  <button type="submit" class="btn btn-outline btn-sm border mr-1">
                    <i class="fas fa-check"></i>
                  </button>
                  <CandidateEditFieldCancelBtn @clicked="editIconState.regFormShow = false">
                    <i class="fas fa-times"></i>
                  </CandidateEditFieldCancelBtn>
                </span>
              </li>

              <li class="list-group-item col-md-6">
                <div
                  v-if="!editIconState.vatFormShow"
                  @mouseover="editFields.vat = true"
                  @mouseleave="editFields.vat = false"
                  class="d-flex"
                >
                  <span>
                    <b>EU VAT number</b>
                  </span>
                  <div v-if="getCandidateById.freelancing_network" class="edit-btn">
                    <router-link v-if="editFields.vat" to>
                      <i @click="showEditForm($event)" id="vat" class="fas fa-pen edit-icon"></i>
                    </router-link>
                  </div>
                  <div>
                    {{ freeLancingProfile.vat }}
                  </div>
                </div>

                <span class="d-flex" v-else>
                  <span class="mr-0">EU VAT number</span>
                  <input
                    id="vat"
                    v-model="editFreeLancer.vat"
                    type="text"
                    class="form-control mr-1"
                  />
                  <button type="submit" class="btn btn-outline btn-sm border mr-1">
                    <i class="fas fa-check"></i>
                  </button>
                  <CandidateEditFieldCancelBtn @clicked="editIconState.vatFormShow = false">
                    <i class="fas fa-times"></i>
                  </CandidateEditFieldCancelBtn>
                </span>
              </li>

              <li class="list-group-item col-md-6">
                <div
                  v-if="!editIconState.streetFormShow"
                  @mouseover="editFields.street = true"
                  @mouseleave="editFields.street = false"
                  class="d-flex"
                >
                  <span>
                    <b>Street address</b>
                  </span>
                  <div v-if="getCandidateById.freelancing_network" class="edit-btn">
                    <router-link v-if="editFields.street" to>
                      <i
                        @click="showEditForm($event)"
                        id="streetFree"
                        class="fas fa-pen edit-icon"
                      ></i>
                    </router-link>
                  </div>
                  <div>
                    {{ freeLancingProfile.street }}
                  </div>
                </div>

                <span class="d-flex" v-else>
                  <span class="mr-0">Street address</span>
                  <input
                    id="freel"
                    v-model="editFreeLancer.street"
                    type="text"
                    class="form-control mr-1"
                  />
                  <button type="submit" class="btn btn-outline btn-sm border mr-1">
                    <i class="fas fa-check"></i>
                  </button>
                  <CandidateEditFieldCancelBtn @clicked="editIconState.streetFormShow = false">
                    <i class="fas fa-times"></i>
                  </CandidateEditFieldCancelBtn>
                </span>
              </li>

              <li class="list-group-item col-md-6">
                <div
                  v-if="!editIconState.pcodeFormShow"
                  @mouseover="editFields.pcode = true"
                  @mouseleave="editFields.pcode = false"
                  class="d-flex"
                >
                  <span>
                    <b>Postal code</b>
                  </span>
                  <div v-if="getCandidateById.freelancing_network" class="edit-btn">
                    <router-link v-if="editFields.pcode" to>
                      <i @click="showEditForm($event)" id="pcode" class="fas fa-pen edit-icon"></i>
                    </router-link>
                  </div>
                  <div>
                    {{ freeLancingProfile.postal }}
                  </div>
                </div>

                <span class="d-flex" v-else>
                  <span class="mr-0">Postal code</span>
                  <input
                    id="freel"
                    v-model="editFreeLancer.postal"
                    type="text"
                    class="form-control mr-1"
                  />
                  <button type="submit" class="btn btn-outline btn-sm border mr-1">
                    <i class="fas fa-check"></i>
                  </button>
                  <CandidateEditFieldCancelBtn @clicked="editIconState.pcodeFormShow = false">
                    <i class="fas fa-times"></i>
                  </CandidateEditFieldCancelBtn>
                </span>
              </li>

              <li class="list-group-item col-md-6">
                <div
                  v-if="!editIconState.freeCityFormShow"
                  @mouseover="editFields.freeCity = true"
                  @mouseleave="editFields.freeCity = false"
                  class="d-flex"
                >
                  <span>
                    <b>Location</b>
                  </span>
                  <div v-if="getCandidateById.freelancing_network" class="edit-btn">
                    <router-link v-if="editFields.freeCity" to>
                      <i
                        @click="showEditForm($event)"
                        id="freeCity"
                        class="fas fa-pen edit-icon"
                      ></i>
                    </router-link>
                  </div>
                  <div>
                    <span v-if="getCandidateById.freelancing_network !== null">
                      {{ freeLancingProfile.city.name }}, {{ freeLancingProfile.country.name }}
                    </span>
                  </div>
                </div>

                <span class="d-flex new-location" v-else>
                  <span class="mr-0">Location</span>
                  <div class="location-container">
                    <v-select
                      class="country-select"
                      v-model="editFreeLancer.country"
                      @input="
                        fetchCitiesByCountryId($event);
                        clearCityFreelancer();
                      "
                      label="name"
                      :options="getAllCountries"
                      :reduce="country => country"
                      :clearable="false"
                    >
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching && search.length >= 3">
                          No results found for <em>{{ search }}</em
                          >.
                        </template>
                        <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                      </template>
                    </v-select>
                    <v-select
                      class="city-select"
                      v-model="editFreeLancer.city"
                      @input="setCityModel($event)"
                      label="name"
                      :options="getCitiesListByCountry"
                      :reduce="city => city"
                      :clearable="true"
                    >
                      <template v-slot:no-options>
                        <div style="opacity: 0.5">Please select a country first</div>
                      </template>
                    </v-select>
                  </div>
                  <button type="submit" class="btn btn-outline btn-sm border mr-1">
                    <i class="fas fa-check"></i>
                  </button>
                  <CandidateEditFieldCancelBtn @clicked="editIconState.freeCityFormShow = false">
                    <i class="fas fa-times"></i>
                  </CandidateEditFieldCancelBtn>
                </span>
              </li>
            </div>
          </ul>
        </div>
        <div
          class="tab-pane fade"
          id="nav-pipelines"
          role="tabpanel"
          aria-labelledby="nav-pipelines-tab"
        >
          <h6 class="pipelines-mobile-title">Pipelines</h6>
          <CandidateItemPipelineMobile />
        </div>
      </div>
    </form>

    <!-- Change Avatar Modal -->
    <div
      class="modal fade edit-modal"
      id="changeAvatarModal"
      tabindex="-1"
      aria-labelledby="changeAvatarModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editModal2Label">Change your profile picture</h5>
            <button
              ref="closeModalUploadAvatarBtn"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div>
              <div class="d-flex justify-content-center my-4">
                <img
                  v-if="!previewAvatar"
                  class="candidate-picture-preview rounded-circle mr-3"
                  :src="getCandidateAvatar"
                  alt="avatar"
                />
                <div
                  v-else
                  class="candidate-picture-preview rounded-circle mr-3"
                  :style="{ 'background-image': `url(${previewAvatar})` }"
                  style="background-size: cover"
                ></div>
              </div>
              <div class="d-flex justify-content-center my-4">
                <span class="mr-2">
                  <label for="upload-avatar" class="btn btn-primary btn-sm file-upload-label mb-0"
                    ><i class="fas fa-upload"></i>Upload picture</label
                  >
                  <input
                    type="file"
                    id="upload-avatar"
                    ref="candidateAvatar"
                    name="candidateAvatar"
                    @input="onCandidateChangeAvatar($event)"
                    accept=".jpg,.png,.jpeg,.gif,.svg"
                  />
                </span>
                <span>
                  <button
                    class="btn btn-danger btn-sm mb-0"
                    @click="onCandidateRemoveAvatar"
                    :disabled="!previewAvatar ? true : false"
                  >
                    <i class="fas fa-upload"></i>Remove picture
                  </button>
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="uploadCandidateAvatar()" type="button" class="btn btn-primary">
              Confirm
            </button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Change Avatar Modal -->

    <!-- Delete Candidate Modal -->
    <div
      class="modal fade edit-modal"
      id="deleteCandidateModal"
      tabindex="-1"
      aria-labelledby="deleteCandidateModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editModal2Label">Delete Candidate</h5>
            <button
              ref="closeModalBtnDelete"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-center justify-content-center">
            <p>
              Please confirm that you want to permanently delete
              {{ getCandidateById.first_name }} {{ getCandidateById.last_name }}. This action will
              disable the candidates account and information in pipelines will be anonymized.
            </p>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="removeCandidate" type="button" class="btn btn-primary">Delete</button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Delete Candidate Modal -->

    <!-- Merge Candidate -->
    <div
      class="modal fade edit-modal"
      id="mergeCandidateModal"
      tabindex="-1"
      aria-labelledby="mergeCandidateModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="mergeLabel">Merge Duplicates</h5>
            <button
              ref="closeModalBtnMerge"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="resetMerge"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-center justify-content-center">
            <div v-if="mergeStep === 1">
              <p>
                Merge the current record with the record with the following primary email:
              </p>
              <div class="form-group m-label-left filter-item">
                <input v-model="mergeEmail" id="mergeEmail" class="form-control" type="email" />
                <label for="mergeEmail">Email</label>
              </div>
            </div>
            <div v-if="mergeStep === 2">
              <p>
                Please confirm that you want to merge
                <strong>{{ getCandidateById.first_name }} {{ getCandidateById.last_name }}</strong>
                with
                <strong>{{ mergeCandidateFirstName }} {{ mergeCandidateLastName }}.</strong> The
                current record will have priority.
              </p>
            </div>
            <Spinner :isLoading="isMergeLoading" />
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button
              v-if="mergeStep === 1"
              @click="searchMergeCandidate"
              type="button"
              class="btn btn-primary"
            >
              Merge
            </button>
            <button v-else @click="mergeCandidates" type="button" class="btn btn-primary">
              Merge
            </button>
            <button
              ref="closeModalBtn"
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="resetMerge"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- END ROW -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CandidateEditFieldCancelBtn from '../common/CandidateEditFieldCancelBtn';
import Comments from '../common/Comments';
import Emails from '../common/Emails';
import CandidateItemPipelineMobile from './CandidateItemPipelineMobile';
import CustomMainModal from '@/components/Modals/CustomMainModal';
import Activities from '../common/Activities';
import AddCandidateBtnModal from './AddCandidateBtnModal';
import IconMapper from '../../common/iconMapper';
import svgHelper from '../../common/svgHelper.vue';
import Avatar from './CandidateAvatar.vue';
import { employmentMixin } from '../../../mixins/employmentMixin';

import { errorService } from '../../../services/errorService';
import axios from 'axios';
import titleMixin from '../../../mixins/titleMixin';

export default {
  components: {
    Avatar,
    CustomMainModal,
    AddCandidateBtnModal,
    CandidateEditFieldCancelBtn,
    Comments,
    Activities,
    Emails,
    CandidateItemPipelineMobile,
    IconMapper,
    svgHelper,
  },
  mixins: [employmentMixin, titleMixin],
  title() {
    return 'Candidate | Jobshark';
  },
  data: () => ({
    isMergeLoading: false,
    mergeStep: 1,
    mergeEmail: '',
    mergeCandidateFirstName: '',
    mergeCandidateLastName: '',
    isCvLoading: false,
    rand: '',
    avatar: '',
    previewAvatar: '',
    defaultCv: '',
    previewCvMessage: '',
    isLoading: false,
    key: 0,
    showModal: false,
    showMore: false,
    selectedRelocation: false,
    selectedOptedOut: false,
    selectedBlocked: false,
    active: false,
    isInEditMode: false,
    isInGlobalEditMode: false,
    candidateId: '',
    candidateData: {},
    selectedEmploymentType: 0,
    selectedCompetences: [],
    competencesOptions: [],
    selectedLanguages: [],
    languagesOptions: [],
    selectedCountry: '',
    selectedCity: '',
    countryId: '',
    cityId: '',
    showCv: false,
    phone: '',
    selectedFirstName: '',
    selectedLastName: '',
    selectedPrimaryEmail: '',
    selectedSecondaryEmail: '',
    selectedPhone: '',
    countryCode: '',
    selectedAddress: '',
    selectedPostalCode: '',
    selectedLinkedin: '',
    selectedWebPage: '',
    selectedAvatar: '',
    /* Freelancing variables */
    freelancingSignInDate: '',
    freelancingStatusCode: '',
    freelancingCompanyName: '',
    freelancingdRegNumber: '',
    freelancingVat: '',
    freelancingAddress: '',
    freelancingPostalCode: '',
    freelancingCountry: '',
    freelancingCity: '',
    selectedTest: 0,
    selectedStreetAddress: '',

    freeLancingProfile: {
      signInDate: '',
      status: '',
      company: '',
      regNumber: '',
      vat: '',
      street: '',
      postal: '',
      city: {},
      country: {},
    },

    editFreeLancer: {
      signInDate: '',
      status: '',
      company: '',
      regNumber: '',
      vat: '',
      street: '',
      postal: '',
      city: {},
      country: {},
    },

    editFields: {
      name: false,
      primaryEmail: false,
      secondaryEmail: false,
      phone: false,
      skype: false,
      streetAddr: false,
      postal: false,
      city: false,
      country: false,
      linkedin: false,
      webpage: false,
      competences: false,
      languages: false,
      employment: false,
      createdBy: false,
      sources: false,
      editRelocation: false,
      editOptedout: false,
      editBlocked: false,
      freelancer: false,
      status: false,
      companyName: false,
      reg: false,
      vat: false,
      street: false,
      pcode: false,
      freeCountry: false,
      freeCity: false,
    },
    editIconState: {
      statusFormShow: false,
      companyNameFormShow: false,
      streetFormShow: false,
      vatFormShow: false,
      regFormShow: false,
      nameFormShow: false,
      primaryEmailFormShow: false,
      secondaryEmailFormShow: false,
      phoneFormShow: false,
      skypeFormShow: false,
      streetAddrFormShow: false,
      postalFormShow: false,
      cityFormShow: false,
      countryFormShow: false,
      linkedinFormShow: false,
      webpageFormShow: false,
      competencesFormShow: false,
      languagesFormShow: false,
      employmentFormShow: false,
      createdByFormShow: false,
      relocationFormShow: false,
      optedoutFormShow: false,
      blockedFormShow: false,
      sourcesFormShow: false,
      freelancerFormShow: false,
      pcodeFormShow: false,
      freeCountryFormShow: false,
      freeCityFormShow: false,
    },
    candidateToDelete: '',
  }),
  methods: {
    ...mapActions([
      'retrieveCitiesListByCountryId',
      'retrieveCandidateDocuments',
      'retrieveCandidateDocument',
      'retrieveDocumentPreview',
      'retrieveCandidateComments',
      'retrieveCandidateAvatar',
      'removeCandidateComment',
      'retrieveCandidateById',
      'candidateDeleteAvatar',
      'candidateUpladAvatar',
      'addCandidateComment',
      'editCandidateById',
      'deleteCandidate',
      'editComment',
      'retrieveCompetencesList',
      'retrieveSourcesList',
      'retrieveCandidates',
    ]),

    setFreeLancerValues() {
      this.freeLancingProfile.signInDate = this.getCandidateById.freelancing_network.signing_date;
      this.freeLancingProfile.status = this.getCandidateById.freelancing_network.status;
      this.freeLancingProfile.company = this.getCandidateById.freelancing_network.company_name;
      this.freeLancingProfile.regNumber = this.getCandidateById.freelancing_network.registration_number;
      this.freeLancingProfile.vat = this.getCandidateById.freelancing_network.eu_vat_number;
      this.freeLancingProfile.street = this.getCandidateById.freelancing_network.street_address;
      this.freeLancingProfile.postal = this.getCandidateById.freelancing_network.postal_code;
      this.freeLancingProfile.country = this.getCandidateById.freelancing_network.country;
      this.freeLancingProfile.city = this.getCandidateById.freelancing_network.city;
    },
    setFreeLancerEditValues() {
      this.editFreeLancer.signInDate = this.getCandidateById.freelancing_network.signing_date;
      this.editFreeLancer.status = this.getCandidateById.freelancing_network.status;
      this.editFreeLancer.company = this.getCandidateById.freelancing_network.company_name;
      this.editFreeLancer.regNumber = this.getCandidateById.freelancing_network.registration_number;
      this.editFreeLancer.vat = this.getCandidateById.freelancing_network.eu_vat_number;
      this.editFreeLancer.street = this.getCandidateById.freelancing_network.street_address;
      this.editFreeLancer.postal = this.getCandidateById.freelancing_network.postal_code;
      this.editFreeLancer.country = this.getCandidateById.freelancing_network.country;
      this.editFreeLancer.city = this.getCandidateById.freelancing_network.city;
    },
    freelancingStatus(status) {
      if (status === 1) {
        return 'Not applied';
      } else if (status === 2) {
        return 'Applied';
      } else if (status === 3) {
        return 'Revised';
      } else if (status === 4) {
        return 'Approved';
      } else {
        return 'Declined';
      }
    },
    seenProfile() {
      axios.post(
        `${process.env.VUE_APP_API_URL}/admin/recentseen/store`,
        {
          candidate_id: this.$route.params.candidate_id,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
        },
      );
    },
    onCloseModal() {
      this.showModal = false;
    },
    resetMerge() {
      this.mergeStep = 1;
      this.mergeEmail = '';
      this.mergeCandidateFirstName = '';
      this.mergeCandidateLastName = '';
    },
    checkLinkedIin(url) {
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return 'https://' + url;
      } else {
        return url;
      }
    },
    addCountryCode(code) {
      this.countryCode = code.replace(/[0-9+]/g, '');
      this.selectedPhone = code.substring(0, code.indexOf(' ')) + ' ';
    },
    clearCity() {
      this.selectedCity = '';
    },
    clearCityFreelancer() {
      this.editFreeLancer.city = '';
    },
    onCancelUpdateForm() {
      this.isInGlobalEditMode = false;
      this.$refs.updateForm.reset();
      this.candidateData = this.getCandidateById;
      //  this.$set(this.candidateData, e.target.id, e.target.value);
    },
    setNewAvatar() {
      this.retrieveCandidateById({ uuid: this.$route.params.candidate_id }).then(() => {
        this.selectedAvatar = this.getCandidateById.photo;
      });
    },
    removeCandidate() {
      this.deleteCandidate({ candidate_id: this.$route.params.candidate_id })
        .then(() => {
          this.$toasted.show('Candidate Deleted', {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });

          this.$refs.closeModalBtnDelete.click();
          setTimeout(() => {
            this.$router.push({ name: 'admin-candidates' });
          }, 700);
        })
        .catch(err => {
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    /* setCandidateToDelete(candidate) {
      this.candidateToDelete = candidate;
    }, */
    onCandidateChangeAvatar(e) {
      let maxSize = 2 * 1024 * 1024;
      if (e.target.files[0].size <= maxSize) {
        this.avatar = e.target.files[0];

        if (this.avatar) {
          const reader = new FileReader();

          reader.onload = e => {
            this.previewAvatar = e.target.result;
          };

          reader.readAsDataURL(this.avatar);
        }
      } else {
        this.$toasted.error('The file size exceeds the limit of 2MB.', {
          theme: 'bubble',
          icon: 'fa-unlock-alt',
          position: 'bottom-right',
          duration: 5000,
        });
      }
    },
    onCandidateRemoveAvatar() {
      this.isLoading = true;
      this.candidateDeleteAvatar({ candidate_id: this.$route.params.candidate_id })
        .then(() => {
          this.isLoading = false;

          this.$toasted.show('Avatar Deleted', {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });

          this.$refs.closeModalUploadAvatarBtn.click();
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    uploadCandidateAvatar() {
      this.isLoading = true;

      const formData = new FormData();

      formData.append('candidate_id', this.$route.params.candidate_id);
      formData.append('image', this.avatar);

      this.candidateUpladAvatar({
        formData,
      })
        .then(() => {
          this.isLoading = false;

          // this.$refs.closeModalUploadAvatarBtn.click();

          /* this.retrieveCandidateAvatar({ uuid: this.$route.params.candidate_id }).then(() => {
            this.$toasted.show('Avatar Updated', {
              theme: 'bubble',
              icon: 'fa-unlock-alt',
              position: 'bottom-right',
              duration: 5000,
            });
          }); */

          this.rand = Date.now();

          this.$emit('candidateInfoUpdated');

          this.$refs.closeModalUploadAvatarBtn.click();
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        });

      this.isLoading = false;
    },
    fetchCitiesByCountryId(country) {
      // this.selectedCountry = e;
      this.retrieveCitiesListByCountryId({ id: country.id });
    },
    setCityModel(e) {
      this.cityId = e;
    },
    onLanguageSearch(search, loading) {
      if (search.length >= 3) {
        loading(true);
        this.languagesOptions = this.getLanguagesList;
      }

      loading(false);
    },
    forceRerender() {
      this.key += 1;
    },
    showMoreCompetences() {
      this.showMore = !this.showMore;
    },

    searchMergeCandidate() {
      if (this.mergeEmail.length > 3) {
        this.isMergeLoading = true;
        this.retrieveCandidates({
          search_word: this.mergeEmail,
          page: 1,
          count: 1,
          optedOut: false,
          freelancers: false,
        })
          .then(res => {
            if (res.data.data.length > 0) {
              this.mergeStep++;
              this.mergeCandidateFirstName = res.data.data[0].first_name;
              this.mergeCandidateLastName = res.data.data[0].last_name;
            } else {
              this.$toasted.error('No records found.', {
                theme: 'bubble',
                icon: 'fa-unlock-alt',
                position: 'bottom-right',
                duration: 5000,
              });
            }
            this.isMergeLoading = false;
          })
          .catch(err => {
            this.isMergeLoading = false;
            console.log(err);
          });
      } else {
        this.$toasted.error('Invalid email.', {
          theme: 'bubble',
          icon: 'fa-unlock-alt',
          position: 'bottom-right',
          duration: 5000,
        });
      }
    },
    mergeCandidates() {
      this.isMergeLoading = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/admin/candidate/merge`,
          {
            main_email: this.getCandidateById.email,
            secondary_email: this.mergeEmail,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.$refs.closeModalBtnMerge.click();
          this.getFreshCandidate();
          this.isMergeLoading = false;
          this.isInGlobalEditMode = false;
          this.$emit('reloadCandidate');
          this.$toasted.success('Success.', {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(err => {
          this.isMergeLoading = false;
          this.$toasted.error('Error.', {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    updateCandidate() {
      console.log(this.selectedBlocked);
      if (this.getCandidateById.freelancing_network !== null) {
        this.updateFreeLancer();
      }
      if (!this.selectedCity.id && !this.selectedCountry.id) {
        this.$toasted.error(`Please enter City and Country before editing other information`, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
        return false;
      } else {
        this.editCandidateById({
          js_candidate_id: this.$route.params.candidate_id,
          first_name: this.selectedFirstName,
          last_name: this.selectedLastName,
          email: this.selectedPrimaryEmail,
          email2: this.selectedSecondaryEmail,

          // country_code: this.candidateData.country_code,
          phone_number: this.selectedPhone,
          street: this.selectedAddress,
          postal: this.selectedPostalCode,
          city_id: this.selectedCity.id,
          country_id: this.selectedCountry.id,
          linkedin: this.selectedLinkedin,
          webpage: this.selectedWebPage,
          languages: this.selectedLanguages.map(l => l.id),
          competences: this.selectedCompetences.map(c => c.id),
          employment_type: this.selectedEmploymentType,
          opted_out: this.selectedOptedOut,
          blocked: this.selectedBlocked,
          relocation: this.selectedRelocation,
          source: this.source,
        })
          .then(() => {
            this.retrieveCandidateById({ uuid: this.$route.params.candidate_id }).then(() => {
              if (this.getCandidateById.freelancing_network !== null) {
                this.setFreeLancerValues();
                this.setFreeLancerEditValues();
              }
              for (const key in this.editIconState) {
                this.editIconState[key] = false;
              }
              this.selectedCompetences = this.getCandidateById.competences.map(c => {
                return { ...c, id: c.competence_id };
              });
              this.selectedLanguages = this.getCandidateById.competences.map(l => {
                return { ...l, id: l.language_id };
              });
              this.selectedFirstName = this.getCandidateById.first_name;
              this.selectedLastName = this.getCandidateById.last_name;
              this.selectedCountry = this.getCandidateById.country;
              this.selectedCity = this.getCandidateById.city;
              this.selectedEmploymentType = this.getCandidateById.employment;
              this.selectedOptedOut = this.getCandidateById.opted_out;
              this.selectedRelocation = this.getCandidateById.relocation;
              this.selectedPhone = this.getCandidateById.phone;
              this.selectedPrimaryEmail = this.getCandidateById.email;
              this.selectedSecondaryEmail = this.getCandidateById.email2;
              this.selectedAddress = this.getCandidateById.street;
              this.selectedWebPage = this.getCandidateById.webpage;
              this.source = this.getCandidateById.source;
              this.selectedAvatar = this.getCandidateById.photo;
              this.selectedPostalCode = this.getCandidateById.postal;
              this.selectedFreelancer = this.customDateFromat(
                this.getCandidateById.freelancer_network,
              );
            });
            this.$toasted.success('Candidate Updated', {
              theme: 'bubble',
              icon: 'fa-unlock-alt',
              position: 'bottom-right',
              duration: 5000,
            });
          })
          .catch(err => {
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-unlock-alt',
              position: 'bottom-right',
              duration: 5000,
            });
          });

        this.$emit('candidateInfoUpdated');

        this.isInGlobalEditMode = false;
      }
    },

    updateFreeLancer() {
      axios.post(
        `${process.env.VUE_APP_API_URL}/admin/freelancer/update`,
        {
          candidate_fn_id: this.getCandidateById.freelancing_network.freelancing_network_id,
          company_name: this.editFreeLancer.company,
          registration_number: this.editFreeLancer.regNumber,
          eu_vat_number: this.editFreeLancer.vat,
          street_address: this.editFreeLancer.street,
          postal_code: this.editFreeLancer.postal,
          city_id: this.editFreeLancer.city.id,
          country_id: this.editFreeLancer.country.id,
          status: this.editFreeLancer.status,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
        },
      );
    },

    changeGlobalEditMode() {
      if (!this.isInEditMode) {
        this.countryCode = this.addCountryName(this.getCandidateById.phone);
        this.selectedFirstName = this.getCandidateById.first_name;
        this.selectedLastName = this.getCandidateById.last_name;
        this.selectedPrimaryEmail = this.getCandidateById.email;
        this.selectedSecondaryEmail = this.getCandidateById.email2;
        this.selectedPhone = this.getCandidateById.phone;
        this.selectedAddress = this.getCandidateById.street;
        this.selectedPostalCode = this.getCandidateById.postal;
        this.selectedLinkedin = this.getCandidateById.linkedin;
        this.selectedWebPage = this.getCandidateById.webpage;
        this.selectedCity = this.getCandidateById.city;
        this.selectedCountry = this.getCandidateById.country;
        this.selectedFreelancer = this.customDateFromat(this.getCandidateById.freelancer_network);
        this.selectedCompetences = this.getCandidateById.competences.map(c => {
          return { ...c, id: c.competence_id };
        });

        this.selectedLanguages = this.getCandidateById.languages.map(l => {
          return { ...l, id: l.language_id };
        });
      }

      this.isInGlobalEditMode = !this.isInGlobalEditMode;
    },
    addCountryName(phone) {
      if (phone !== null) {
        let extractedNumbers = phone.match(/^(\+\d+)\s/);
        if (extractedNumbers) {
          let countryCode = extractedNumbers[1]; // Extracted numbers before the space
          let exists = this.getAllCountries.find(country => country.phone_code === countryCode);

          if (exists) {
            return exists.name;
          } else {
            return '';
          }
        }
      }
    },
    showEditForm(e) {
      if (e.target.id !== 'city' && !this.getCandidateById.city && !this.getCandidateById.country) {
        this.$toasted.error(`Please enter City and Country before editing other information`, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      } else {
        if (e.target.id === 'freelancer') {
          this.editIconState.freelancerFormShow = !this.editIconState.freelancerFormShow;
        }
        if (e.target.id === 'streetFree') {
          this.editFreeLancer.street = this.getCandidateById.freelancing_network.street_address;

          this.editIconState.streetFormShow = !this.editIconState.streetFormShow;
        }
        if (e.target.id === 'freeCountry') {
          this.editIconState.freeCountryFormShow = !this.editIconState.freeCountryFormShow;
        }
        if (e.target.id === 'freeCity') {
          this.editIconState.freeCityFormShow = !this.editIconState.freeCityFormShow;
        }
        if (e.target.id === 'vat') {
          this.editFreeLancer.vat = this.getCandidateById.freelancing_network.eu_vat_number;

          this.editIconState.vatFormShow = !this.editIconState.vatFormShow;
        }
        if (e.target.id === 'reg') {
          this.editFreeLancer.regNumber = this.getCandidateById.freelancing_network.registration_number;
          this.editIconState.regFormShow = !this.editIconState.regFormShow;
        }
        if (e.target.id === 'pcode') {
          this.editFreeLancer.postal = this.getCandidateById.freelancing_network.postal_code;

          this.editIconState.pcodeFormShow = !this.editIconState.pcodeFormShow;
        }
        if (e.target.id === 'status' && this.getCandidateById.freelancing_network !== null) {
          this.editFreeLancer.status = this.getCandidateById.freelancing_network.status;
          this.editIconState.statusFormShow = !this.editIconState.statusFormShow;
        }

        if (e.target.id === 'companyname') {
          this.editFreeLancer.company = this.getCandidateById.freelancing_network.company_name;
          this.editIconState.companyNameFormShow = !this.editIconState.companyNameFormShow;
        }
        if (e.target.id === 'candidate-name') {
          this.editIconState.nameFormShow = !this.editIconState.nameFormShow;
        }
        if (e.target.id === 'primary-email') {
          this.editIconState.primaryEmailFormShow = !this.editIconState.primaryEmailFormShow;
        }
        if (e.target.id === 'phone-number') {
          this.selectedPhone = this.getCandidateById.phone;
          this.countryCode = this.addCountryName(this.getCandidateById.phone);
          this.editIconState.phoneFormShow = !this.editIconState.phoneFormShow;
        }
        if (e.target.id === 'email2') {
          this.selectedSecondaryEmail = this.getCandidateById.email2;

          this.editIconState.secondaryEmailFormShow = !this.editIconState.secondaryEmailFormShow;
        }
        if (e.target.id === 'street') {
          this.selectedAddress = this.getCandidateById.street;

          this.editIconState.streetAddrFormShow = !this.editIconState.streetAddrFormShow;
        }
        if (e.target.id === 'postal') {
          this.selectedPostalCode = this.getCandidateById.postal;

          this.editIconState.postalFormShow = !this.editIconState.postalFormShow;
        }
        if (e.target.id === 'country') {
          this.selectedCountry = this.getCandidateById.country;

          this.editIconState.countryFormShow = !this.editIconState.countryFormShow;
        }
        if (e.target.id === 'linkedin') {
          this.selectedLinkedin = this.getCandidateById.linkedin;

          this.editIconState.linkedinFormShow = !this.editIconState.linkedinFormShow;
        }
        if (e.target.id === 'competences') {
          this.selectedCompetences = this.getCandidateById.competences.map(c => {
            return { ...c, id: c.competence_id };
          });

          this.editIconState.competencesFormShow = !this.editIconState.competencesFormShow;
        }
        if (e.target.id === 'employment') {
          this.selectedEmploymentType = this.getCandidateById.employment;

          this.editIconState.employmentFormShow = !this.editIconState.employmentFormShow;
        }
        if (e.target.id === 'createdBy') {
          this.editIconState.createdByFormShow = !this.editIconState.createdByFormShow;
        }
        if (e.target.id === 'city') {
          this.selectedCity = this.getCandidateById.city;

          this.editIconState.cityFormShow = !this.editIconState.cityFormShow;
        }
        if (e.target.id === 'webpage') {
          this.selectedWebPage = this.getCandidateById.webpage;

          this.editIconState.webpageFormShow = !this.editIconState.webpageFormShow;
        }
        if (e.target.id === 'languages') {
          this.selectedLanguages = this.getCandidateById.languages.map(l => {
            return { ...l, id: l.language_id };
          });

          this.editIconState.languagesFormShow = !this.editIconState.languagesFormShow;
        }
        if (e.target.id === 'relocation') {
          this.selectedRelocation = this.getCandidateById.relocation;

          this.editIconState.relocationFormShow = !this.editIconState.relocationFormShow;
        }
        if (e.target.id === 'optedout') {
          this.selectedOptedOut = this.getCandidateById.opted_out;

          this.editIconState.optedoutFormShow = !this.editIconState.optedoutFormShow;
        }
        if (e.target.id === 'blocked') {
          // this.selectedBlocked = this.getCandidateById.blocked;

          this.editIconState.blockedFormShow = !this.editIconState.blockedFormShow;
        }
        if (e.target.id === 'sources') {
          this.source = this.getCandidateById.source;

          this.editIconState.sourcesFormShow = !this.editIconState.sourcesFormShow;
        }
      }
    },
    setDefaultCvDocument() {
      this.isLoading = true;
    },
    onCvDocumentView() {
      this.isCvLoading = true;
      this.showCv = true;

      const defaultDoc =
        this.getCandidateById.documents.find(doc => doc.is_default === true) || null;

      this.getCandidateDocuments.length ? '' : (this.previewCvMessage = 'No CV has been uploaded');

      if (defaultDoc) {
        this.retrieveDocumentPreview({ uuid: defaultDoc.id, preview: 'true' })
          .then(response => {
            const blob = new window.Blob([response.data], { type: 'application/pdf' });
            const objectUrl = URL.createObjectURL(blob);

            this.defaultCv = objectUrl;

            this.setPdfPreview(response.data.type);
            this.isCvLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
            this.defaultCv = null;
            this.isCvLoading = false;
          });
      } else {
        this.isCvLoading = false;
        this.showCv = false;
        this.previewCvMessage = 'No primary CV has been selected';
      }

      this.isLoading = false;
    },
    setPdfPreview(fileName) {
      if (fileName === 'application/pdf') {
        this.showCv = true;
      } else {
        this.previewCvMessage = 'Sorry, this document cannot be previewed.';
        this.showCv = false;
      }
    },
    deleteCommentHandler(commentID) {
      this.removeCandidateComment({ uuid: commentID })
        .then(() => {
          this.retrieveCandidateComments({ uuid: this.$route.params.candidate_id });

          this.$toasted.show('Comment Deleted', {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(err => {
          this.$toasted.error(err.response.data.message, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 10000,
          });
        });
    },
    addCommentHandler(comment) {
      if (comment) {
        const normalizedComment = comment.trim();

        this.addCandidateComment({
          uuid: this.$route.params.candidate_id,
          message: normalizedComment,
        })
          .then(() => {
            this.retrieveCandidateComments({ uuid: this.$route.params.candidate_id });

            this.$toasted.success('Comment Added', {
              theme: 'bubble',
              icon: 'fa-unlock-alt',
              position: 'bottom-right',
              duration: 5000,
            });
          })
          .catch(err => {
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-unlock-alt',
              position: 'bottom-right',
              duration: 5000,
            });
          });
      } else {
        this.$toasted.info(`Enter your comment first and then hit "Add Comment" button`, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 10000,
        });
      }
    },
    editCommentHandler(commentData) {
      this.editComment({ uuid: commentData.id, data: commentData.comment })
        .then(() => {
          this.retrieveCandidateComments({ uuid: this.$route.params.candidate_id });

          this.$toasted.success(`Comment updated`, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(() => {
          this.$toasted.error(`Edit comment failed.`, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 10000,
          });
        });
    },

    customDateFromat(dateString) {
      if (dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
    },

    getFreshCandidate() {
      this.retrieveCandidateById({ uuid: this.$route.params.candidate_id }).then(response => {
        if (this.getCandidateById.freelancing_network !== null) {
          this.setFreeLancerValues();
          this.setFreeLancerEditValues();
        }
        this.updateMeta();
        if (response.data.country) {
          this.fetchCitiesByCountryId(response.data.country);
        }

        /* v-select value for edit */
        this.selectedLanguages = this.getCandidateById.languages.map(lang => {
          return { ...lang, id: lang.language_id };
        });

        this.selectedCompetences = this.getCandidateById.competences.map(competence => {
          return { ...competence, id: competence.competence_id };
        });

        this.selectedFirstName = this.getCandidateById.first_name;
        this.selectedLastName = this.getCandidateById.last_name;
        this.selectedCountry = this.getCandidateById.country;
        this.selectedCity = this.getCandidateById.city;
        this.selectedEmploymentType = this.getCandidateById.employment;
        this.selectedOptedOut = this.getCandidateById.opted_out;
        this.selectedRelocation = this.getCandidateById.relocation;
        this.selectedFreelancer = this.customDateFromat(this.getCandidateById.freelancer_network);
        if (this.getCandidateById.phone !== null) {
          this.selectedPhone = this.getCandidateById.phone;
        } else {
          this.selectedPhone = '';
        }
        this.selectedPrimaryEmail = this.getCandidateById.email;
        this.selectedSecondaryEmail = this.getCandidateById.email2;
        this.selectedAddress = this.getCandidateById.street;
        this.selectedWebPage = this.getCandidateById.webpage;
        this.source = this.getCandidateById.source;
        this.selectedAvatar = this.getCandidateById.photo;
        this.selectedLinkedin = this.getCandidateById.linkedin;
        this.selectedPostalCode = this.getCandidateById.postal;
        if (this.getCandidateById.user_status === 101) {
          this.selectedBlocked = true;
        }
      });
    },
  },
  computed: {
    ...mapGetters([
      'getCompetencesFilterList',
      'getCitiesListByCountry',
      'getCandidateDocuments',
      'getCandidateComments',
      'getCandidateEmails',
      'getCandidateAvatar',
      'getCandidateById',
      'getAllCountries',
      'getUserProfile',
      'getLanguagesList',
      'getAccType',
    ]),
  },
  mounted() {
    this.seenProfile();
    this.retrieveCandidateById({ uuid: this.$route.params.candidate_id }).then(response => {
      if (this.getCandidateById.freelancing_network !== null) {
        this.setFreeLancerValues();
        this.setFreeLancerEditValues();
      }
      this.updateMeta();
      if (response.data.country) {
        this.fetchCitiesByCountryId(response.data.country);
      }

      /* v-select value for edit */
      this.selectedLanguages = this.getCandidateById.languages.map(lang => {
        return { ...lang, id: lang.language_id };
      });

      this.selectedCompetences = this.getCandidateById.competences.map(competence => {
        return { ...competence, id: competence.competence_id };
      });

      this.selectedFirstName = this.getCandidateById.first_name;
      this.selectedLastName = this.getCandidateById.last_name;
      this.selectedCountry = this.getCandidateById.country;
      this.selectedCity = this.getCandidateById.city;
      this.selectedEmploymentType = this.getCandidateById.employment;
      this.selectedOptedOut = this.getCandidateById.opted_out;
      this.selectedRelocation = this.getCandidateById.relocation;
      this.selectedFreelancer = this.customDateFromat(this.getCandidateById.freelancer_network);
      if (this.getCandidateById.phone !== null) {
        this.selectedPhone = this.getCandidateById.phone;
      } else {
        this.selectedPhone = '';
      }
      this.selectedPrimaryEmail = this.getCandidateById.email;
      this.selectedSecondaryEmail = this.getCandidateById.email2;
      this.selectedAddress = this.getCandidateById.street;
      this.selectedWebPage = this.getCandidateById.webpage;
      this.source = this.getCandidateById.source;
      this.selectedAvatar = this.getCandidateById.photo;
      this.selectedLinkedin = this.getCandidateById.linkedin;
      this.selectedPostalCode = this.getCandidateById.postal;
      if (this.getCandidateById.user_status === 101) {
        this.selectedBlocked = true;
      }
    });
    this.retrieveCandidateComments({ uuid: this.$route.params.candidate_id });
    this.retrieveCompetencesList();
    this.retrieveSourcesList();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/_functions.scss';

.badge {
  background: mix($color-white, $btn-default-color, 50);
  color: #fff;
  margin-left: 5px;
  text-align: center;
  animation: pulse 2s infinite;
  animation-duration: pulse 10s;
  -webkit-animation-duration: 5s;
}

.advertising {
  font-family: $font-family-sans-lato;
  padding: 40px 20px;
  .form-group {
    margin-bottom: 20px;
    label {
      font-size: 14px;
      font-weight: 700;
    }
    .form-control {
      margin-top: 0 !important;
      height: 38px !important;
    }
  }
  .view-link {
    .btn-outline {
      color: red;
      width: 31px;
      height: 31px;
      &:first-of-type {
        color: green;
      }
    }
    &:hover {
      .show {
        opacity: 1 !important;
      }
    }
  }
}

@keyframes pulse {
  0% {
  }
  50% {
    -moz-box-shadow: 0 0 0 0 $color-orange;
    box-shadow: 0 0 0 0 $color-orange;
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}

.opted-checkbox {
  margin-right: 1rem;
}

.pipelines-mobile-title {
  display: none;
}

.list-group {
  .list-group-item {
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
    background-color: transparent;
    padding-right: 0;
  }
}
.v-select {
  position: relative;
  top: -6px;
  margin-right: 5px;
  margin-left: 20px;
}

.employment-select {
  font-family: $font-family-sans-lato;
  font-size: 13px;
  margin-top: -8px;
}

.candidate-edit {
  &-icon {
    fill: #a3a6b4;
    margin-top: -5px;
  }

  &-icon:hover {
    fill: #c1c4d4;
  }
}

.candidate-info-form {
  .form-control {
    margin-left: 20px;
    display: block;
  }
  button {
    border-radius: 0.25rem;
    position: relative;

    i {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 12px;
    }
  }
  .edit-btn {
    width: 25px;
    height: 25px;
    a {
      text-decoration: none;
    }
    i {
      color: #777;
      display: block;
      width: 100%;
      text-decoration: none;
    }
    &.mr {
      margin: 0 6px 0 8px;
    }
  }

  .custom-checkbox {
    margin-left: 46px !important;
  }
  .creation-date {
    margin-left: 25px !important;
  }
}

.edit-icon {
  font-size: 1.1rem !important;
}

.candidate-details {
  font-family: $font-family-sans-lato;
  font-size: 0.875rem;
  overflow: hidden;

  .row {
    margin: 0;
  }

  li.list-group-item {
    padding-left: 0 !important;
    border: none !important;
  }

  li > .d-flex {
    border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
    margin: 3px 12px;
    padding: 12px 0;
    height: 46px;
  }

  li span {
    min-width: 133px !important;

    white-space: nowrap;
  }

  li > span:not(:nth-child(2n + 0)) {
    font-weight: 700;
    min-width: 19rem;
  }

  .popup {
    background: #fff;
    border: 1px solid #ddd;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
    position: absolute;
    padding: 8px 12px 6px 12px !important;
    top: 75%;
    left: -15px;
    width: 100%;
    height: auto !important;
    z-index: 9;
    flex-wrap: wrap;
  }

  .tech-icons {
    width: 100%;
    position: relative;
    margin-top: -20px;
    .icon-container {
      width: 22%;
      text-align: center;
      display: inline-block;
      .icon-wrapper {
        img {
          width: 25px;
          height: 25px;
          display: block;
          margin: 0 auto;
        }
      }
    }
    .btn-secondary {
      background: none !important;
      border: none !important;
      box-shadow: none !important;
      position: absolute;
      top: 13px;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .dropdown-menu {
      width: 100%;
      border-radius: 0;
      .list-inline {
        li {
          margin: 0;
          text-align: center;
          width: 25%;
        }
      }
    }
    .dropdown-toggle {
      &:after {
        display: none;
      }
    }
  }

  .btn {
    min-width: 22px;
    min-height: 12px;
    background: #fff;
    margin-top: -3px;
    color: #28a745;
    &:hover {
      background: #fafafa;
    }
    &:nth-of-type(2) {
      color: red;
    }
  }
}

.card-primary {
  height: 970px;
}

/* CANDIDATE TAGS */
.candidate-tag {
  border: 1px solid #a3a6b4;
  border-radius: 20px;
  color: #a3a6b4;
  padding: 6px 10px;
}

.candidate-tag-selected {
  cursor: pointer;
  color: $color-orange;
  border: 1px solid $color-orange;
}

.candidate-picture {
  position: relative;
  width: 64px;
  height: 64px;
  margin-right: 12px !important;
  flex-shrink: 0;
  .btn-success {
    margin-right: 10px;
  }
  .overlay {
    cursor: pointer;
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    font-size: 21px;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.125);
    opacity: 0;
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    -ms-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
  }
  &:hover {
    .overlay {
      opacity: 1;
    }
  }
}

.candidate-picture-preview {
  width: 13rem;
  height: 13rem;
}

.card {
  min-height: auto;
  .tab-content {
    margin: 1rem;
  }
}

.mobile-only {
  display: none !important;
}

.candidate-main-info {
  flex: 1;
  .candidate-name {
    flex: 1;
    .fields {
      flex: 1;
    }
  }
  .edit-candidate {
    margin-left: 6px;
    .btn-primary,
    .btn-danger {
      margin-left: 12px;
    }
  }
}

.custom-control {
  padding-left: 0;
}

@media only screen and (max-width: 992px) {
  .card {
    min-height: auto;
    height: auto !important;
    overflow: hidden;
    .tab-content {
      margin: 0;
    }
  }
  .comments {
    padding: 0 18px;
  }

  .mobile-only {
    display: block !important;
  }
  .edit-btn {
    position: absolute;
    right: 5px;
  }
  .candidate-details {
    .row {
      margin: 0 12px;
    }
  }
}

@media only screen and (max-width: 768px) {
  .page-title {
    display: none !important;
  }
  .candidate-picture {
    .candidate-edit {
      width: 40%;
    }
  }
  .card {
    min-height: auto;
    height: auto !important;
    overflow: hidden;
    .tab-content {
      margin: 0;
    }
  }
  .candidate-details {
    .primary-cv {
      display: block !important;
    }
    /* .list-group-item {
      .d-flex {
      }
    } */
  }
  .mobile-only {
    display: block !important;
  }
  .edit-btn {
    position: absolute;
    right: 5px;
  }
}

@media only screen and (max-width: 576px) {
  .card {
    min-height: 100%;
    padding-bottom: 40px;
    .tab-content {
      margin: 0;
    }
  }

  .candidate-details {
    margin-top: 20px;
    .btn {
      min-width: 30px !important;
      height: 30px;
      position: relative;
      top: -3px;
      margin-left: 6px;
      font-size: 14px !important;
    }
  }

  .candidate-picture {
    width: 43px !important;
    height: 43px !important;
    position: absolute;
    top: 10px;
    right: 20px;
    img {
      width: 43px !important;
      height: 43px !important;
      object-fit: cover;
    }
  }
  .edit-btn {
    position: absolute;
    right: 5px;
  }
  .candidate-details {
    .list-group-item {
      span {
        margin-right: 25px;
      }
      .mobile-name {
        margin-right: 27px !important;
      }
      .custom-checkbox {
        margin-left: 0px !important;
      }
      .tech-icons {
        padding-left: 0 !important;
        margin-left: -5px;
        span {
          margin-right: 0;
        }
      }
      .popup {
        span {
          margin-left: 0 !important;
          margin-right: 0 !important;
        }
      }
      .creation-date {
        margin-left: 0 !important;
      }
    }
  }
  .mobile-hidden {
    display: none !important;
  }
  .mobile-only {
    display: block !important;
  }
  .comments {
    padding: 8px;
  }
}

/* CANDIDATE TAGS END*/
</style>
